import { SidebarNavItem, SiteConfig } from "types";

const site_url = process.env.NEXT_PUBLIC_BASE_URL;

export const siteConfig: SiteConfig = {
    name: `${process.env.NEXT_PUBLIC_SITE_DISPLAY_NAME}`,
    description: "Johanna's personal website",
    url: site_url!,
    ogImage: "", // `${site_url}/_static/og.jpg`,
    links: {
        twitter: "none",
        github: "none",
        // twitter: "https://twitter.com/miickasmt",
        // github: "mickasmt/next-saas-stripe-starter",
    },
    mailSupport: "support@johannahendrix.com",
};

export const footerLinks: SidebarNavItem[] = [
    // {
    //     title: "Company",
    //     items: [
    //         { title: "About", href: "#" },
    //         { title: "Enterprise", href: "#" },
    //         { title: "Terms", href: "/terms" },
    //         { title: "Privacy", href: "/privacy" },
    //     ],
    // },
    // {
    //     title: "Product",
    //     items: [
    //         { title: "Security", href: "#" },
    //         { title: "Customization", href: "#" },
    //         { title: "Customers", href: "#" },
    //         { title: "Changelog", href: "#" },
    //     ],
    // },
    // {
    //     title: "Docs",
    //     items: [
    //         { title: "Introduction", href: "#" },
    //         { title: "Installation", href: "#" },
    //         { title: "Components", href: "#" },
    //         { title: "Code Blocks", href: "#" },
    //     ],
    // },
];
